/**
 * A function for styling images based on a portion of the URL within an article section
 */
const styleArticleImages = () => {
  const articleSection = document.querySelector('section[data-section-type="article"]');

  console.log(0, articleSection);

  if (!articleSection) return;

  const images = articleSection.querySelectorAll('img[src*="flavcity.com/wp-content/uploads/"]');

  images.forEach(img => {
    img.style.maxHeight = '30px';
  });
};

document.addEventListener('DOMContentLoaded', styleArticleImages);

class ArticleNav extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.blogUrl = this.dataset.blogUrl;
    this.articleHandle = this.dataset.articleHandle;
    this.paginatePartsSize = parseInt(this.dataset.paginatePartsSize);
    this.requestTemplate = this.dataset.requestTemplate;

    this.newerPostEl = this.querySelector('[data-newer-post]');
    this.olderPostEl = this.querySelector('[data-older-post]');

    this.init();
  }

  async init() {
    const cached = this.getCachedData();

    if (cached) {
      this.resolveNavigation(cached);
    } else {
      const allArticles = await this.fetchAllArticles();
      this.setCachedData(allArticles);
      this.resolveNavigation(allArticles);
    }
  }

  buildPageUrl(page) {
    return `${this.blogUrl}?page=${page}&${this.requestTemplate}`;
  }

  async fetchAllArticles() {
    const promises = Array.from({ length: this.paginatePartsSize }, (_, i) => {
      const url = this.buildPageUrl(i + 1);

      return fetch(url)
        .then((res) => res.text())
        .then((text) => {
          try {
            const parsed = JSON.parse(text);
            return Array.isArray(parsed) ? parsed : [];
          } catch (e) {}

          const parser = new DOMParser();
          const doc = parser.parseFromString(text, 'text/html');
          const jsonEl = doc.querySelector('#fc-blog[type="application/json"]');

          if (jsonEl) {
            try {
              const parsed = JSON.parse(jsonEl.textContent);
              return Array.isArray(parsed) ? parsed : [];
            } catch (e) {
              console.warn(`ArticleNav: unable to parse JSON from ${url}`, e);
              return [];
            }
          }

          return [];
        })
        .catch((err) => {
          console.warn(`ArticleNav: failed to download ${url}`, err);
          return [];
        });
    });

    const results = await Promise.all(promises);
    return results.flat();
  }

  resolveNavigation(allArticles) {
    const currentIndex = allArticles.findIndex(
      (item) => item.handle === this.articleHandle
    );

    if (currentIndex === -1) {
      console.warn('ArticleNav: the current article was not found', this.articleHandle);
      this.hideAll();
      return;
    }

    const newerArticle = currentIndex > 0 ? allArticles[currentIndex - 1] : null;
    const olderArticle = currentIndex < allArticles.length - 1 ? allArticles[currentIndex + 1] : null;

    if (newerArticle) {
      this.newerPostEl.href = newerArticle.url;
      this.newerPostEl.title = newerArticle.title;
      this.newerPostEl.setAttribute('aria-label', `Newer Post: ${newerArticle.title}`);
    } else {
      this.hideNavElement(this.newerPostEl);
    }

    if (olderArticle) {
      this.olderPostEl.href = olderArticle.url;
      this.olderPostEl.title = olderArticle.title;
      this.olderPostEl.setAttribute('aria-label', `Older Post: ${olderArticle.title}`);
    } else {
      this.hideNavElement(this.olderPostEl);
    }
  }

  hideAll() {
    this.hideNavElement(this.newerPostEl);
    this.hideNavElement(this.olderPostEl);
  }

  hideNavElement(el) {
    const wrapper = el.closest('small');
    if (!wrapper) return;

    wrapper.classList.add('hidden');
    wrapper.setAttribute('aria-hidden', 'true');
    wrapper.setAttribute('hidden', '');
    el.setAttribute('tabindex', '-1');
  }

  getCachedData() {
    try {
      const cacheKey = `fc_blog_${this.blogUrl}`;
      const cached = sessionStorage.getItem(cacheKey);
      return cached ? JSON.parse(cached) : null;
    } catch (e) {
      console.warn('ArticleNav getCachedData: cache read error', e);
      return null;
    }
  }

  setCachedData(data) {
    try {
      const cacheKey = `fc_blog_${this.blogUrl}`;
      sessionStorage.setItem(cacheKey, JSON.stringify(data));
    } catch (e) {
      console.warn('ArticleNav setCachedData: cache write error', e);
    }
  }
}

customElements.define('article-nav', ArticleNav);